import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InvioDatiPageComponent} from './invio-dati-page/invio-dati-page.component';
import {InvioFilePageComponent} from './invio-file-page/invio-file-page.component';
import { ListaPageComponent } from './lista-page/lista-page.component';


const trasmissioneReportNetRoutes: Routes = [
  {
    path: 'invio-dati',
    component: InvioDatiPageComponent,
    children: [],
    // canActivate: [authGuard]
  },
  {
    path: 'invio-file',
    component: InvioFilePageComponent,
    children: [],
    // canActivate: [authGuard]
  },
  {
    path: 'lista-page',
    component: ListaPageComponent,
    children: [],
    // canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: 'lista', 
    pathMatch: 'full'
    // canActivate: [authGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(trasmissioneReportNetRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class TrasmissioneReportNetRoutingModule {
}
